import { useAnalytics } from '@satellite/composables/useAnalytics';
import type { TrackOptions } from '@satellite/analytics/AnalyticsClient';
import {
  Events,
  type ApplicationLanguageSwitchedPayload,
  type LunaEventsMap
} from '@/analytics/events';

export type TrackApplicationLanguageSwitchedOptions =
  TrackOptions<ApplicationLanguageSwitchedPayload>;

/** Site language selector (LocaleSelector) analytics. */
export function useLocaleAnalytics() {
  const analytics = useAnalytics<LunaEventsMap>();

  function trackApplicationLanguageSwitched(
    params: ApplicationLanguageSwitchedPayload,
    options: TrackApplicationLanguageSwitchedOptions = {}
  ) {
    const payload: ApplicationLanguageSwitchedPayload = {
      ...params,
      ...(options.additionalPayload ?? {})
    };
    analytics.track(Events.LANGUAGE.SWITCHED, payload);
  }

  return { trackApplicationLanguageSwitched };
}
